import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextQuestionsInputComponent } from './text-questions-input/text-questions-input.component';
import { ButtonModule } from '../../../shared/components/games';
import { TranslateModule } from '@ngx-translate/core';
import { RangePercentComponent } from './range-percent/range-percent.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    TextQuestionsInputComponent,
    RangePercentComponent,
  ],
  exports: [
    TextQuestionsInputComponent,
    RangePercentComponent,
  ],
  imports: [
    CommonModule,
    ButtonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
  ],
})
export class SharedModule { }
